import { Component, render, h } from 'preact';
import { I } from 'intl';
import { TcrLogin } from '../components/login';
import { TcrLoginForm } from '../components/login-form';
import { TcrUserInterface } from '../components/user-interface';
import { TcrTitleBar } from '../components/title-bar';
import { TcrAboutPage } from '../components/about-page';

class TrCloudJournals extends Component
{
    constructor(props)
    {
        super(props);

		I.Refresh = { de: 'Aktualisieren', en: 'Refresh' };
		I.Login = { de: 'Anmelden', en: 'Log in' };
		I.Logout = { de: 'Abmelden', en: 'Log out' };
		I.RenameCollection = { de: 'Kollektion umbenennen', en: 'Rename collection' };
		I.NewCollection = { de: 'Neue Kollektion', en: 'New collection' };
		I.DeleteCollection = { de: 'Kollektion löschen', en: 'Delete collection' };
		I.Delete = { de: 'Löschen', en: 'Delete' };
		I.Cancel = { de: 'Abbrechen', en: 'Cancel' };
		I.ChangeColor = { de: 'Farbe ändern', en: 'Change color' };
		I.ManagePermission = { de: 'Berechtigungen verwalten', en: 'Manage permissions' };
		I.MarkAsRead = { de: 'Kollektion als gelesen markieren', en: 'Mark collection as read' };
		I.MarkAsReadForAll = { de: 'Kollektion als gelesen markieren (für alle)', en: 'Mark collection as read (for all)' };
        I.Ok = { de: 'OK', en: 'OK' };

        this.loginStatusChanged = this.loginStatusChanged.bind(this);

		I.setLanguages(['en', 'de']);

		window.runningInApp = !!window.ReactNativeWebView;
    }

    componentDidMount()
	{
		TcrLogin.checkStatus(this.loginStatusChanged);
	}

    loginStatusChanged(s)
	{
        this.setState({
            login: s.status === true
        });
	}

    async logout()
	{
		await TcrLogin.logout();
		document.location.reload();
	}
	
    render()
    {
        let ui = {
			appBar: {
				visible: true,
				maskedLogo: '/wp-content/plugins/tcr-login/modules/cloud/icons/wiki_icon_wide_mask.png',
				actions: []
			}
		};
		if (window.trcloud.logo)
		{
			ui.appBar.logo = window.trcloud.logo;
			delete ui.appBar.maskedLogo;
		}
        if (this.state.login === true)
		{
            ui.contentView = {
                visible: true,
                component: [
                    <TcrTitleBar title="Willkommen" />,
                    <div class="tile">
                        Sie haben sich erfolgreich angemeldet, Ihnen fehlt jedoch die nötige Berechtigung auf diesen Bereich zuzugreifen.<br/><br/>
						Wenden Sie sich an den Verantwortlichen in Ihrem Unternehmen.
                    </div>
                ]
            }
			ui.appBar.actions.push({
				type: 'menu',
				image: '/wp-content/plugins/tcr-login/modules/cloud/icons/user-icon.png',
				items: [
					{
						label: I.Refresh,
						run: () => { document.location.reload(); }
					},{
						label: I.Logout,
						run: this.logout
					}
				]
			});
        }
        else if (this.state.login === false)
		{
			if (!window.trcloud.sso || !window.trcloud.sso.exclusive || true)
			{
				ui.loginForm = {
					visible: true,
					sso: window.trcloud.sso || false,
					footer: {
						content: trcloud.footer || '',
						links: [
							{ title: 'Imprint', link: '/imprint/'},
							{ title: 'Privacy policy', link: '/privacy/'}
						]
					}
				};
			}
			else
			{
				ui.appBar.actions.push({
					type: 'button',
					label: I.Login,
					run: TcrLogin.do_sso
				});
				ui.contentView = {
					visible: true,
					component: [
						<TcrAboutPage />
					]
				}
			}
		}
        return (
            <TcrUserInterface id="trcloud-journals-ui" config={ui} accent={window.trcloud.accent || ''}>
				<TcrLoginForm config={ui.loginForm} onError={e => MessageBox.show(e)} />
            </TcrUserInterface>
        );
    }
}

const domContainer = document.querySelector('body');
render(<TrCloudJournals />, domContainer);
